var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSumInsured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78627 5.81625C5.19377 7.1295 2.625 10.5799 2.625 14.625V20.25C2.625 22.3211 4.305 24 6.375 24H17.625C19.695 24 21.375 22.3211 21.375 20.25C21.375 17.76 21.375 14.625 21.375 14.625C21.375 10.5802 18.8062 7.13062 15.2137 5.817C16.2112 5.1855 17.01 4.27012 17.4975 3.18674C17.8163 2.49112 17.76 1.68112 17.3475 1.03687C16.9313 0.39075 16.2187 0 15.45 0C13.5225 0 10.4738 -8.70321e-07 8.54251 0.0119991C7.78501 0.0119991 7.07626 0.400874 6.66376 1.04325C6.25501 1.68412 6.19875 2.48887 6.51375 3.18075C6.9975 4.26712 7.79252 5.184 8.78627 5.81625ZM15.75 9.75H8.25V11.25H10.5C11.4788 11.25 12.3113 11.8763 12.6225 12.75H8.25V14.25H12.6225C12.315 15.1237 11.4788 15.75 10.5 15.75H8.25V17.205L12.9938 21.5527L14.0062 20.4473L10.5188 17.2496C12.3263 17.2414 13.83 15.9559 14.175 14.25H15.75V12.75H14.175C14.0625 12.1958 13.8263 11.6861 13.5 11.25H15.75V9.75Z",
    fill: "#717F91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumInsured);
export default __webpack_public_path__ + "static/media/sum_insured.175c6f479b3f68eb388ce5edefb06bbc.svg";
export { ForwardRef as ReactComponent };